// eslint-disable-next-line no-restricted-imports
import type { MemberResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import type { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
// eslint-disable-next-line no-restricted-imports
import type { Action } from '@trello/redux';
// eslint-disable-next-line no-restricted-imports
import { actionCreator } from '@trello/redux';
import { client } from '@trello/graphql';
// eslint-disable-next-line no-restricted-imports
import type { State } from 'app/gamma/src/modules/types';
import type {
  LoadHeaderQuery,
  LoadHeaderQueryVariables,
} from './LoadHeaderQuery.generated';
import { LoadHeaderDocument } from './LoadHeaderQuery.generated';
import { cacheFactory } from '@trello/quickload';

// Action types
export const LOAD_HEADER_REQUEST = Symbol('loaders/LOAD_HEADER_REQUEST');
export const LOAD_HEADER_SUCCESS = Symbol('loaders/LOAD_HEADER_SUCCESS');

export type LoadHeaderRequestAction = Action<
  typeof LOAD_HEADER_REQUEST,
  string
>;
export type LoadHeaderSuccessAction = Action<
  typeof LOAD_HEADER_SUCCESS,
  MemberResponse
>;

// Action creators
const loadHeaderRequest = actionCreator<LoadHeaderRequestAction>(
  LOAD_HEADER_REQUEST,
);
const loadHeaderSuccess = actionCreator<LoadHeaderSuccessAction>(
  LOAD_HEADER_SUCCESS,
);

export const loadHeader = (idMember: string): StandardThunkAction => {
  return async (dispatch: Dispatch, getState: () => State) => {
    dispatch(loadHeaderRequest(idMember));

    await Promise.all([
      cacheFactory.waitForQueryHydratedTo('MemberHeader', 'Apollo'),
      cacheFactory.waitForQueryHydratedTo('MemberBoards', 'Apollo'),
    ]);
    const { data, error } = await client.query<
      LoadHeaderQuery,
      LoadHeaderQueryVariables
    >({
      query: LoadHeaderDocument,
      variables: {
        id: idMember,
      },
      context: {
        operationName: 'LoadHeader',
        document: LoadHeaderDocument,
      },
    });
    const member = data.member;
    if (error || !member) {
      return;
    }

    dispatch(loadHeaderSuccess(member));
  };
};
